import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { spaceMap } from '../utils/spaceMap';
var flexGrowMap = {
  hug: {
    flexGrow: 0
  },
  fill: {
    width: '100%',
    flexGrow: 1
  }
};
export function Inline(_ref) {
  var forgeDoc = _ref.forgeDoc,
    render = _ref.render;
  var _ref2 = forgeDoc.props,
    alignBlock = _ref2.alignBlock,
    alignInline = _ref2.alignInline,
    spread = _ref2.spread,
    space = _ref2.space,
    grow = _ref2.grow,
    shouldWrap = _ref2.shouldWrap,
    rowSpace = _ref2.rowSpace;
  var justifyContent = spread || alignInline;
  var growProps = grow ? flexGrowMap[grow] : undefined;
  var gap = space && spaceMap[space];
  var rowGap = rowSpace && spaceMap[rowSpace];
  return /*#__PURE__*/React.createElement("div", {
    style: _objectSpread(_objectSpread({
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      display: 'flex',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      flexDirection: 'row',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      gap: gap,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      justifyContent: justifyContent,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      alignItems: alignBlock
    }, growProps), {}, {
      flexWrap: shouldWrap ? 'wrap' : undefined,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      rowGap: rowGap
    })
  }, forgeDoc.children.map(render));
}